import useMutation from "src/hooks/useMutation";

function useManufacturerUpdate(id) {
  return useMutation({
    path: `/api/v1/manufacturers/${id}`,
    method: "PUT",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/manufacturers`,
      shouldRevalidate: true,
    },
  });
}

export default useManufacturerUpdate;
